import {  Pivot, PivotItem } from "@fluentui/react";
import React,{useContext,useState} from "react";
import FroalaEditor from 'react-froala-wysiwyg';
import Froalaeditor from 'froala-editor'
import FroalaEditorButton from "react-froala-wysiwyg/FroalaEditorButton";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";

const EditorSection = () => {


    const {
        model,
        setModel,
        patientReports,
        setPatientReports,
        showToast,
        setShowToast,
        selectedCategoryTemplate,
        setSelectedCategoryTemplate,
        allReportTemplates,
        setAllReportTemplates,
        dropdownSelectedTemplates,
        setDropdownSelectedTemplates,
        reset,
        setReset,
        userActionLoading,
        setUserActionLoading,
    
        handleDropdown,
        handleModelChange,
        handleRemoveTemplate,
        handleChangeTemplate,
        handleActiveTab
      } = useContext(studyReportContext);

      const config= {
        placeholderText: 'Edit Your Content Here!',
        key: "FROALA_KEY",
        attribution: false,
        height: '32vh',
        width:800,
        pluginsEnabled: [
            'fullscreen',
            'codeBeautifier',
            'colors',
            'fontFamily',
            'fontSize',
            "paragraphFormat", 
            "paragraphStyle",
            "align",
            "lists",
            "table"
          ],
        toolbarButtons: {
            moreText: {              
              buttons: [  
                'undo', 'redo',
                "|",
                "paragraphFormat",
                "|",
                'fontFamily',
                "|",
                'fontSize',
                "|",
                'bold',
                'italic',
                'underline',
                'strikeThrough',
                'clearFormatting',
                "|",  
                'textColor',
                'backgroundColor',
                "|",
                'alignLeft',
                'alignCenter',
                'alignRight',
                'alignJustify',
                // 'inlineClass',
                // 'inlineStyle',
                "formatOL",
                "formatUL",
                "outdent",
                "indent",
                "|",
                "insertTable",
                "|",
                "copy",
    
              ],
              align: 'left',
              buttonsVisible: 10,
            },
            // moreParagraph: {
            //     buttons: ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'],
            //     align: 'left',
            //     buttonsVisible: 10
            //   },
          
              // moreRich: {
              //   buttons: ['insertLink', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertFile', 'insertHR'],
              //   align: 'left',
              //   buttonsVisible: 10
              // },
          
            //   moreMisc: {
            //     buttons: [ "copy",'fullscreen', 'print','copyToClipboard', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'],
            //     align: 'right',
            //     buttonsVisible: 10
            //   }
        },
        // events: {
        //   'click': function (clickEvent) {
        //    // setShowToast(false);
        //     console.log(this);
        //   }
        // }
    }

    Froalaeditor.DefineIcon('copy', { NAME: 'insert', SVG_KEY: 'add' })
    Froalaeditor.RegisterCommand('copy', {
      title: 'Copy',
      focus: true,
      undo: true,
      refreshAfterCallback: true,
      callback: function() {
        var html = this.html.get() ;
        var div = document.createElement("div");
        div.innerHTML = html;
        // console.log(div.innerText);
        var textField = document.createElement('textarea')
        // console.log(div.innerHTML);
        textField.innerHTML = html;
        // console.log(textField);
        textField.select()
        document.execCommand("selectall", null, false);
        document.execCommand('copy');
        // console.log(html);
        if(html != ""){
          setShowToast(true);
        }
        
        textField.remove()
      },
    });

    return (
        <Pivot style={{textAlign:'center'}} aria-label="Count and Icon Pivot Example">
                <PivotItem headerText="Final Report">
                       <FroalaEditor
                      tag='textarea'
                      config={config}
                      model={model}
                      onModelChange={handleModelChange}
                      style={{marginTop:"20px"}}
                  />
                </PivotItem>
                <PivotItem headerText="Addendum" aria-disabled="false">
                 <FroalaEditor
                      tag='textarea'
                      config={config}
                      model={"Addendum text"}
                      // onModelChange={handleModelChange}
                  />
                </PivotItem> 
          </Pivot>
       
    );
};

export default EditorSection;